import { CONSENT_ACCESS_LABS_COMPLETED } from '@/consts/consentTypes';
import type { ConsentMetadata } from '@/services/api';

export const LABS_CONSENT_VERSION = 1;
export const LABS_CONSENT_SOURCE = 'access_registration';

export const buildLabsConsent = (hasLabs: boolean, dateReported: number): ConsentMetadata => ({
  version: LABS_CONSENT_VERSION,
  status: hasLabs ? 'consent' : 'revoked',
  dateReported,
  source: LABS_CONSENT_SOURCE,
  userMetadataObjectType: CONSENT_ACCESS_LABS_COMPLETED,
});
